"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DefaultFastenersGroup_1 = __importDefault(require("./DefaultFastenersGroup"));
exports.default = DefaultFastenersGroup_1.default;
